import {Injectable} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {MatomoTracker} from 'ngx-matomo-client';


/**
 * Service zum automatischen Tracken von Seitenaufrufen via Matomo.
 *
 * @see https://www.npmjs.com/package/ngx-matomo-client
 */
@Injectable({
  providedIn: 'root',
})
export class MatomoTrackerService {
  /**
   * Initialisiert das Tracking: Abonnieren der Router-Events.
   *
   * @param router Angular Router, um Navigation-End-Events zu empfangen.
   * @param matomo MatomoTracker-Service zum Senden der Tracking-Daten.
   */
  constructor(
    private router: Router,
    private matomo: MatomoTracker
  ) {
    this.initRouteTracking();
  }

  /**
   * Meldet sich beim Router an und trackt jede abgeschlossene Navigation.
   *
   * @private
   */
  private initRouteTracking(): void {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd)
      )
      .subscribe(event => {
        /* INFO: Mit setCustomUrl wird die URL für das Tracking überschrieben,
           falls Angular-Route vom Browser-URL-Pfad abweicht. */
        this.matomo.setCustomUrl(event.urlAfterRedirects);
        // INFO: trackPageView sendet den Pageview an Matomo.
        this.matomo.trackPageView();
      });
  }

  public trackMatomoEvent(category: string, action: string): void {
    if ((window as any)._paq) {
      (window as any)._paq.push(['trackEvent', 'Agrarinfo | ' + category, action]);
    }
  }
}
